
<div class="d-flex filter-header-rt floatinghead clearfix">
  <div class="rightside d-flex ml-auto" *ngIf="IsEmployee&&propertyList?.length>0 && permissionService.hasPermission(Modules.Employees,Actions.AssociationsEdit)">
    <div style="padding-left: 5px" *ngIf="!IsEditClicked">
      <button type="button" class="btn  btn-circle btn-green"
              tooltip="Bulk Update" triggers="mouseenter:mouseleave"
              placement="left" (click)="editUserOffers()">
        <i aria-hidden="true" class="icofont icofont-ui-edit icon"></i>
      </button>
    </div>

  </div>
  <div class="rightside d-flex ml-auto margin-bottom-15" *ngIf="IsEditClicked">
    <label style="padding-top:17px;">Assign New User</label>
    <div style="padding-left: 5px; padding-top: 10px;">
      <label class="select">
        <select name="cmbBroker" class="form-control " [(ngModel)]="bulkBrokerId" (click)="onBrokerClick();" (change)="onBulkBrokerChange($event)">
          <option value="0">Select</option>
          <option *ngFor="let broker of brokers" [(ngValue)]="broker.Id">{{broker.Name}}</option>
        </select>
      </label>
    </div>
  </div>
</div>
<div class="cf"></div>
<div class="table-responsive table-fixed table-v-scroll margin0" style="width: 100%">
  <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
    <thead>
      <tr>
        <th data-orderable="false" style="width:5px" [hidden]="!IsEditClicked">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>Select
          </label>
        </th>
        <th style="width:2px" [hidden]="!IsEditClicked" data-orderable="false">
        </th>
        <th [hidden]="IsPrincipal">Buyer Name</th>
        <th>Tenant Name</th>
        <th>Status</th>
        <th>Offer Date</th>
        <th>Offer Price</th>
        <th>Asking Price</th>
        <th data-orderable="false" [hidden]="!IsEditClicked">Assign New User</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let property of propertyList;let i = index">
        <td [hidden]="!IsEditClicked">
          <label class="custom-checkbox withoutlabel" *ngIf="property.IsCoBroker">
            <input type="checkbox" [(ngModel)]="property.IsSelected" (change)="onCheckboxChange($event,property.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
          </label>
        </td>
        <td [hidden]="!IsEditClicked"></td>
        <td class="sticky-left" [hidden]="IsPrincipal">
          <div style="display:table">
            <p><a href="javascript:void(0);" routerLink="/offer-detail/{{property.OfferDetailGuid}}" [queryParams]="{prevroute:'Offers', link : 'offers-list?fromMenu=Opportunity'}">{{property.LeadName}}</a></p>
          </div>
        </td>
        <td>
          <p *ngIf="!IsPrincipal"><a href="javascript:void(0);" routerLink="/viewproperty/{{property.PropertyGuid}}">{{property.PropertyName}}</a></p>
          <p *ngIf="IsPrincipal"><a href="javascript:void(0);" routerLink="/offer-detail/{{property.OfferDetailGuid}}" [queryParams]="{prevroute:'Offers', link : 'offers-list?fromMenu=Opportunity'}">{{property.PropertyName}}</a></p>
        </td>
        <td>
          <p>{{property.Status}}</p>
        </td>
        <td>
          <p>{{ (property.OfferDate) ? (Validation.convertUTCDateToLocalDate(property.OfferDate)| date:'MM/dd/yyyy') : '-'}}</p>
        </td>
        <td>

          <p> {{(property.Price!=null&&property.Price>=0) ?'$ '+ (property.Price | number:0) : '-'}}</p>
        </td>
        <td>
          <p> {{(property.Price!=null&&property.Price>=0) ?'$ '+ (property.Price | number:0) : '-'}}</p>
        </td>
        <td [hidden]="!IsEditClicked">
          <label class="select" *ngIf="property.IsCoBroker">
            <select name="cmbBroker" class="form-control " (change)="onBrokerChange($event,property)" [(ngModel)]="property.BrokerId">
              <option value="0">Select</option>
              <option *ngFor="let broker of brokers" value="{{broker.Id}}">{{broker.Name}}</option>
            </select>
          </label>
        </td>
      </tr>

    </tbody>
    <tfoot>
      <tr *ngIf="propertyList?.length == 0&&!IsDataProcessing">
        <td colspan="5" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>

</div>
<div class="text-right margin-top-10" *ngIf="IsEditClicked">
  <button type="button" class="btn btn-default btn-lg" (click)="clearSelectedContact()">Cancel</button>
  <button class="btn btn-success  btn-lg" (click)="saveUserOffers()">Save</button>
</div>















